import { useQuery } from "@tanstack/react-query";
import { EncounterSummaryControllerApi } from "../../services";
import {
  DEF_PAGINATION,
  getConfigObject,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  pagination?: { page: number; pageSize: number };
  appointmentId?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 * Fetch the paginated therapy note catalog.
 * GET /api/master/encounter-summary/therapy
 * When `appointmentId` is supplied, only therapies linked to that appointment
 * are returned.
 *
 * @author Rajkumar Rathod
 */
export const useGetAllTherapyNotes = ({
  pagination = DEF_PAGINATION,
  appointmentId,
  xTENANTID,
  enabled = true,
}: Props = {}): useBaseContent<any> => {
  return useQuery({
    queryKey: [
      "all-therapy-notes",
      pagination?.page,
      pagination?.pageSize,
      appointmentId,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    enabled,
    queryFn: async () =>
      await new EncounterSummaryControllerApi(getConfigObject())
        .getAllTherapyNotes(
          pagination?.page,
          pagination?.pageSize,
          appointmentId,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
